export const getDateTime = (s) => {
  const timezone = "en-US";
  const dt = new Date(s);

  return `${dt.toLocaleDateString(timezone)} ${dt.toLocaleTimeString(
    timezone
  )}`;
};
